import { NumberFormatToNode, ParseNumber } from "../../../global";

const GetExclusiveId = () => {
    let id = Math.trunc(+new Date() * Math.random())
    return id;
}

const NumberFormat = (num) => NumberFormatToNode(num)
      
const ParseToNumber = (strNum) => ParseNumber(strNum);

const Integer = (a) => {
    if (!a)
        return "0";

    let rgxBrazilianPattern = new RegExp(/^[+-]?(?:\d{0,3}(?:\.\d{3})|0)(?:,\d)?$/g);

    a = a + "";

    if (rgxBrazilianPattern.test(a)) { 
        a = (a).replace(/\./g, "").replace(",", ".");
    } else {
        a = (a).replace(/,/g, "");
    }     

    if (isNaN(a)) {
        return "0";
    }

    let n1 = a.split(".")[0];

    if(a.includes(".")) {
    let n2 = a.split(".")[1];

    if(parseInt(n2) != 0)
        return n1 + "." + n2;
    }

    return n1;
}

const FormatComma = (num) => {
    if ((num.slice(num.indexOf(',') + 1, (num.length)) > 0)) {
        return  num
    } else {
        return  num.slice(0, num.indexOf(','));
    }
} 

const GetSixConections = (node) => {
    const width = node.width - 0.5
    const height = node.height - 0.5
    const halfWidth = width / 6;
    const halfHeight = height / 6;
    let newY = node.y
    let top1 = { x: node.x + halfWidth * 1, y: newY, point: 'top1' };
    let top2 = { x: node.x + halfWidth * 3, y: newY, point: 'top2' };
    let top3 = { x: node.x + halfWidth * 5, y: newY, point: 'top3' };
    let left1 = { x: node.x, y: newY + halfHeight * 1, point: 'left1' };
    let left2 = { x: node.x, y: newY + halfHeight * 3, point: 'left2' };
    let left3 = { x: node.x, y: newY + halfHeight * 5, point: 'left3' };
    let bottom1 = { x: node.x + halfWidth * 1, y: node.y + height, point: 'bottom1' };
    let bottom2 = { x: node.x + halfWidth * 3, y: node.y + height, point: 'bottom2' };
    let bottom3 = { x: node.x + halfWidth * 5, y: node.y + height, point: 'bottom3' };
    let right1 = { x: node.x + width, y: newY + halfHeight * 1, point: 'right1' };
    let right2 = { x: node.x + width, y: newY + halfHeight * 3, point: 'right2' };
    let right3 = { x: node.x + width, y: newY + halfHeight * 5, point: 'right3' };
    return [left1, left2, left3, right1, right2, right3, top1, top2, top3, bottom1, bottom2, bottom3];
};

const GetTransform = () => {
    let transform = document.querySelector('#board').getAttribute('transform')
    if (transform) {
        return BuildTransform(transform)
    }
    return { x: 0, y: 0, scale: 1 }
}

const BuildTransform= function(transform){
    let transformPartial = transform.split(' ')
    let scale = transformPartial[1]
    let width = transformPartial[2]
    
    transform = transform.slice(transform.indexOf('(') + 1, transform.indexOf(')'))
    scale = scale.slice(scale.indexOf('(') + 1, scale.indexOf(')'))
    if(width)
     width = width.slice(width.indexOf('(') + 1, width.indexOf(')'))
    let x = transform.split(',')[0]
    let y = transform.split(',')[1]
    return { x: parseFloat(x), y: parseFloat(y), scale: parseFloat(scale), width: parseFloat(width)}
}

const GetSVGCoordinates = (event) => {
    let boundingClientRect = document.querySelector("#svg").getBoundingClientRect();
    let transform = GetTransform();
    let x;
    let y;

    if (event.type == "drag") {
        x = event.x - window.scrollX;
        y = event.y - window.scrollY;
    } else {
        x = event.pageX - boundingClientRect.left - window.scrollX;
        y = event.pageY - boundingClientRect.top - window.scrollY;
    }

    x -= transform.x;
    y -= transform.y;
    x /= transform.scale;
    y /= transform.scale;

    return [x, y]
}

const GetCoordinateDiff = function(coord, node) {
    return {
        x: coord.x - node.x,
        y: coord.y - node.y
    }
}

const SetArea = async(node, adjust) => {
    let extremes = await GetExtremesCoordinates(node)
    node.x = extremes.min.x - node.r;
    node.y = extremes.min.y - node.r;
    node.height = Math.abs(extremes.max.y - extremes.min.y + adjust);
    node.width = Math.abs(extremes.max.x - extremes.min.x + adjust);
}

const GetExtremesCoordinates = async(node) => {
    let coord = await GetCoordinatePath(node.path)
    let minX = -1;
    let maxX = -1;
    let minY = -1;
    let maxY = -1;

    coord.forEach(c => {
        if (minX == -1) {
            minX = c.x;
            minY = c.y;
        }

        if (c.x < minX)
            minX = c.x
        if (c.x > maxX)
            maxX = c.x

        if (c.y < minY)
            minY = c.y
        if (c.y > maxY)
            maxY = c.y
    });

    return ({ min: { x: minX, y: minY }, max: { x: maxX, y: maxY } })
}

export const GetDimentionsById = (id) => {
    let d = document.querySelector(`#${id}`);
    d = d ? d.getBoundingClientRect() : null;

    if (!d) {
        return
    }

    let svg = document.querySelector("#svg").getBoundingClientRect();
    let transform = GetTransform();

    let x = d.x
    let y = d.y

    x -= (transform.x + svg.left);
    y -= (transform.y + svg.top);
    x /= transform.scale;
    y /= transform.scale;

    return {
        width: d.width / transform.scale,
        height: d.height / transform.scale,
        x,
        y
    }
}

const GetCoordinatePath = (path) => {
    let strCoord = path.replace("M", "").split('L')
    let coord = new Array();

    strCoord.forEach(c => {
        let [x, y] = c.split(",")
        x = parseFloat(x);
        y = parseFloat(y);
        coord.push({ x: x, y: y });
    })

    return coord;
}

export {
    GetExclusiveId,
    NumberFormat,
    ParseToNumber,
    GetSixConections,
    GetSVGCoordinates,
    GetCoordinateDiff,
    SetArea,
    GetExtremesCoordinates,
    GetCoordinatePath,
    Integer,
    FormatComma,
    BuildTransform
}